// extracted by css-extract-rspack-plugin
export default {"root":"root-iTNjU","before":"before-2PdD3","after":"after-Svxiq","secondary":"secondary-25Q9J","error":"error-1--Y2","errorMessage":"errorMessage-2OyDG"};